var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#6868FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64496 9.73913C3.78904 9.45098 4.13943 9.33418 4.42759 9.47826L10 12.2645L15.5725 9.47826C15.8607 9.33418 16.2111 9.45098 16.3551 9.73913C16.4992 10.0273 16.3824 10.3777 16.0943 10.5218L10.4696 13.3341C10.4653 13.3362 10.4603 13.3388 10.4547 13.3416C10.4003 13.3694 10.2877 13.4269 10.1614 13.4506C10.0548 13.4706 9.94533 13.4706 9.8387 13.4506C9.71244 13.4269 9.59981 13.3694 9.54539 13.3416C9.53978 13.3388 9.53479 13.3362 9.53047 13.3341L3.90584 10.5218C3.61768 10.3777 3.50089 10.0273 3.64496 9.73913Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64496 12.6558C3.78904 12.3676 4.13943 12.2508 4.42759 12.3949L10 15.1812L15.5725 12.3949C15.8607 12.2508 16.2111 12.3676 16.3551 12.6558C16.4992 12.944 16.3824 13.2943 16.0943 13.4384L10.4696 16.2507C10.4653 16.2529 10.4603 16.2554 10.4547 16.2583C10.4003 16.2861 10.2877 16.3436 10.1614 16.3672C10.0548 16.3872 9.94533 16.3872 9.8387 16.3672C9.71244 16.3436 9.59981 16.2861 9.54539 16.2583C9.53978 16.2554 9.53479 16.2529 9.53047 16.2507L3.90584 13.4384C3.61768 13.2943 3.50089 12.944 3.64496 12.6558Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8387 3.63277C9.94533 3.61277 10.0548 3.61277 10.1614 3.63277C10.2877 3.65646 10.4003 3.71394 10.4547 3.74171C10.4603 3.74457 10.4653 3.74711 10.4696 3.74927L16.0943 6.56159C16.2919 6.6604 16.4167 6.86239 16.4167 7.08334C16.4167 7.30429 16.2919 7.50628 16.0943 7.60509L10.4696 10.4174C10.4653 10.4196 10.4603 10.4221 10.4547 10.425C10.4003 10.4527 10.2877 10.5102 10.1614 10.5339C10.0548 10.5539 9.94533 10.5539 9.8387 10.5339C9.71244 10.5102 9.59981 10.4527 9.54539 10.425C9.53978 10.4221 9.53479 10.4196 9.53047 10.4174L3.90584 7.60509C3.70821 7.50628 3.58338 7.30429 3.58338 7.08334C3.58338 6.86239 3.70821 6.6604 3.90584 6.56159L9.53047 3.74927C9.53479 3.74711 9.53978 3.74457 9.54539 3.74171C9.59981 3.71394 9.71244 3.65646 9.8387 3.63277Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSop);
export default __webpack_public_path__ + "static/media/sop.69c67244097ebcd15f8e0ab4fd26d317.svg";
export { ForwardRef as ReactComponent };